import {getFirstNameControlMeta, getLastNameControlMeta} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import c from '../../../classnames.scss'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import fs from '../../fields.scss'
import s from './name.scss'
import {NameProps} from './index'

export class Name extends React.Component<NameProps> {
  renderFirstName() {
    const {
      firstName: {
        input: {onChange, onBlur, value},
        meta: {touched, error},
      },
      control,
      disabled,
      t,
    } = this.props
    const {maxLength, label} = getFirstNameControlMeta(control)

    return (
      <div data-hook={touched && error ? DH.FORM_INVALID_FIELD : ''} className={s.wrapper}>
        <Label
          classes={classNames({[fs.disabledCaption]: disabled})}
          dataHook={DH.FIRST_NAME_CAPTION}
          required
          htmlFor="firstName"
          caption={label}
        />
        <input
          className={classNames(c.formInputBorderColor, fs.input, {[c.formInputError]: touched && error})}
          data-hook={DH.FIRST_NAME_INPUT}
          type="text"
          id="firstName"
          value={value}
          maxLength={maxLength}
          required
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
        />
        <Error dataHook={DH.FIRST_NAME_ERROR} error={touched && error && t(error)} />
      </div>
    )
  }

  renderLastName() {
    const {
      lastName: {
        input: {onChange, onBlur, value},
        meta: {touched, error},
      },
      control,
      disabled,
      t,
    } = this.props
    const {maxLength, label} = getLastNameControlMeta(control)

    return (
      <div data-hook={touched && error ? DH.FORM_INVALID_FIELD : ''} className={s.wrapper}>
        <Label
          classes={classNames({[fs.disabledCaption]: disabled})}
          dataHook={DH.LAST_NAME_CAPTION}
          required
          htmlFor="lastName"
          caption={label}
        />
        <input
          className={classNames(c.formInputBorderColor, fs.input, {[c.formInputError]: touched && error})}
          data-hook={DH.LAST_NAME_INPUT}
          type="text"
          id="lastName"
          value={value}
          maxLength={maxLength}
          required
          disabled={disabled}
          onBlur={onBlur}
          onChange={onChange}
        />
        <Error dataHook={DH.LAST_NAME_ERROR} error={touched && error && t(error)} />
      </div>
    )
  }

  render() {
    return (
      <div className={classNames(fs.field, s.container)}>
        {this.renderFirstName()}
        {this.renderLastName()}
      </div>
    )
  }
}
